import type {
  V2AdminDemoFirstRunResetDto,
  V2AdminDemoFirstRunStatusDto
} from '@idc-forms/api-client'

/**
 * Textos de la tarjeta «Cuenta de revisión de tiendas» (ADR 0041).
 *
 * Viven acá, como funciones puras, para poder probarlos sin montar la pantalla.
 */

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`

/** «Términos aceptados: 1 · Sesiones activas: 2 · Avisos push: 0». */
export function firstRunStatusLine(
  status: Pick<V2AdminDemoFirstRunStatusDto, 'acceptances' | 'activeSessions' | 'enabledPushTokens'>
): string {
  return [
    `Términos aceptados: ${status.acceptances}`,
    `Sesiones activas: ${status.activeSessions}`,
    `Avisos push: ${status.enabledPushTokens}`
  ].join(' · ')
}

/** El resumen del toast de éxito, con lo que el reinicio hizo de verdad. */
export function firstRunResetSummary(result: V2AdminDemoFirstRunResetDto): string {
  const acceptances = plural(
    result.acceptancesRemoved,
    'aceptación eliminada',
    'aceptaciones eliminadas'
  )
  const sessions = plural(result.sessionsRevoked, 'sesión cerrada', 'sesiones cerradas')
  const push = plural(result.pushTokensDisabled, 'equipo sin avisos', 'equipos sin avisos')
  return `Cuenta dejada como nueva: ${acceptances}, ${sessions}, ${push}.`
}
